import loadable from '@/utils/loadable';

export const LoginPage = loadable(() => import('@/pages/Auth/Login'));
export const HomePage = loadable(() => import('@/pages/Home'));
export const SportsPage = loadable(() => import('@/pages/Sports'));
export const CasinoGames = loadable(() => import('@/pages/CasinoGames'));
export const GameDetailsPage = loadable(() => import('@/pages/GameDetails'));
export const BetProfitLossPage = loadable(() => import('@/pages/Reports/BetProfitLoss'));
export const BetHistoryPage = loadable(() => import('@/pages/Reports/BetHistory'));
export const UnsettledBetPage = loadable(() => import('@/pages/Reports/UnsettledBet'));
export const StakeSettingsPage = loadable(() => import('@/pages/StakeSettings'));
export const RulesPage = loadable(() => import('@/pages/Rules'));
export const ChangePasswordPage = loadable(() => import('@/pages/ChangePassword'));
export const AccountStatementPage = loadable(() => import('@/pages/Reports/AccountStatement'));
export const ResultsPage = loadable(() => import('@/pages/Results'));
export const InplayPage = loadable(() => import('@/pages/Inplay'));
export const RacingPage = loadable(() => import('@/pages/Racing'));
export const RacingInside = loadable(() => import('@/pages/RacingInside'));
// export const MarketsPage = loadable(() => import('@/pages/Markets'));
// export const CasinoPage = loadable(() => import('@/pages/Casino'));
// export const CasinoPlaygroundPage = loadable(() => import('@/pages/CasinoPlayground'));
// export const QTECHLobbyPage = loadable(() => import('@/pages/QTECHLobby'));
// export const QTECHCasinoPage = loadable(() => import('@/pages/QTECHCasino'));
// export const AccountStatementPage = loadable(() => import('@/pages/AccountStatment'));
// export const BetHistoryPage = loadable(() => import('@/pages/BetHistory'));
// export const ActivityLogsPage = loadable(() => import('@/pages/ActivityLog'));
// export const CasinoResultsPage = loadable(() => import('@/pages/CasinoResults'));
// export const AuthVerificationPage = loadable(() => import('@/pages/AuthVerification'));
// export const ChangePasswordPage = loadable(() => import('@/pages/ChangePassword'));
// export const TermsConditionsPage = loadable(() => import('@/pages/TermsAndConditions'));
// export const CasinoBetHistory = loadable(() => import('@/pages/CasinoBetHistory'));
// export const ResponsibleGamingPage = loadable(() => import('@/pages/ResponsibleGaming'));
